import {
    Component,
    Input,
    Output,
    ElementRef,
    OnInit,
    OnChanges,
    AfterViewInit,
    SimpleChanges,
    EventEmitter
} from '@angular/core';

import {Logger} from "../utils/logger";

@Component({
    selector: 'canvas-img',
    providers: [],    
    templateUrl: "./canvas-image.component.html"
})
export class CanvasImage implements OnInit, AfterViewInit, OnChanges {


    @Input()
    public width;

    @Input()
    public height;

    @Input()
    public marginLeft;

    @Input('className')
    public className = "";

    @Input()
    public imageUrl;

    @Output('load')
    public load:EventEmitter<boolean>;

    constructor(public el:ElementRef, public logger:Logger) {
        this.load = new EventEmitter<boolean>();
    }

    ngAfterViewInit():any {
        var img = this.el.nativeElement.querySelector('.canvas-img');
        img.addEventListener('load', () => {
            $(img).animate({opacity: 1}, 1000);
            this.onLoad();
        })
    }


    ngOnInit():any {

    }

    onLoad() {
        this.load.emit(true);
    }

    ngOnChanges(changes:any):any {
        if (typeof changes.imageUrl !== 'undefined') {
            if (changes.imageUrl.currentValue !== changes.imageUrl.previousValue) {
                var img = this.el.nativeElement.querySelector('.canvas-img');
                if (img) {
                    img.src = changes.imageUrl.currentValue;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/canvas/canvas-image.component.ts